import Vue from 'vue';

Vue.directive("scroll", {
  inserted: function(el, bind, vnode) {
    let top = el.offsetTop,
      pageHeight = document.documentElement.clientHeight,
      cb_name = bind.expression, // 绑定的函数名
      cb = vnode.context[cb_name];

      window.addEventListener("scroll", async () => {
    		// +1防止高度不够
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;       
        if (top - 1 + el.offsetHeight > scrollTop && top - 1 < scrollTop + 0.5*pageHeight) {
        try {
          cb && (await cb()); // 触发绑定的函数
        } catch (error) {
          console.log(error);
        }
      }
    });
  }
});